export const SUBMENU_ITEM_KEYS = {
  label: 'title',
  value: 'name',
}

export const SUBMENU_UNREAD_KEYS = {
  all: 'all',
  unread: 'unread',
}
